import Vue from 'vue'
import Router from 'vue-router'

// add lk 2020/4/8 start
import Store from '@/store/index'
import lk from '@/api/lk'
import G from '@/views/common/global'
import LoginIndex from '@/views/login/index'
import MobileScan from '@/views/source/mobileScan'
import MqttShow from '@/views/MQTT/Preview_Mqtt'
//add by lcc 2021-7-29 start
import vor from '@/views/safety/vor'
import vor4 from '@/views/safety/vor4'
//add by lcc 2021-7-29 end
Vue.use(Router)
let routerMap = [
    {
        name: '登录',
        path: '/login/:id',
        
        component: LoginIndex,
        meta: { title: '登录', keepAlive: false, show: false, id: 2, parentId: 0 }
    },
    {
        name: '考勤',
        path: '/source/mobileScan',
        component: MobileScan,
        meta: { title: '考勤', keepAlive: false, show: false, id: 555, parentId: 0 }
    },
    {
        name: 'MQTT面板展示',
        path: '/mqttshow',
        component: MqttShow,
        meta: { title: 'MQTT展示', keepAlive: false, show: false, id: 557, parentId: 0 }
    },
    {
        name: '隐患列表',
        path: '/safety/vor',
        component: vor,
    },
    {
        name: '巡查统计',
        path: '/safety/vor4',
        component: vor4,
    }
]
let router = null;
router = new Router({
    mode: 'hash',
    routes: routerMap,
    scrollBehavior(to, from, savedPosition) {
        if (to.meta.scrollTop) {
            return { x: 0, y: 0 }
        }
    }
})
let breadList = []
router.beforeEach((to, from, next) => {
    console.log(to.path)
    Store.commit('SET_ACTIVEMENU', to.path)
    // const username = Cookie.get('username');
    // const token = Cookie.get('token');
    sessionStorage.setItem('project', localStorage.getItem('project'))
    sessionStorage.setItem('username', localStorage.getItem('username'))
    sessionStorage.setItem('token', localStorage.getItem('token'))
    const username = sessionStorage.getItem('username');
    const token = sessionStorage.getItem('token')
    const title = G.htmlTitle
    document.title = title + '-' + to.meta.title

    if (to.path == '/') {
        next('/login/2');
        return
    }else
    if (to.path.indexOf('/login') != -1) {
        if (typeof (token) == 'undefined' || token === '' || token == null || token === 'null') {
            if (from.path != '/') {
                location.reload()
            }
            next();
            return
        } else {
            next();
            // lk.compareToken({ username: username, token: token }).then(res => {
            //     if (res.code == 200) {
            //         Store.dispatch('GetMenu')
            //         next('/index')
            //         // next(from.path)
            //         return
            //     } else {
            //         next()
            //         return
            //     }
            // })
        }
    } else if (to.path === '/source/mobileScan') {
        next()
    }
    else {
        if (typeof (token) == 'undefined' || token === '' || token == null || token === 'null') {
            next({
                path: "/login/2",
                // query: { redirect: to.path }
            })
            return
        } else {
            Store.dispatch('GetInfo')
            Store.dispatch('GetMenu')
            breadList = [{ path: to.path, title: to.name, level: to.meta.level }]
            Store.commit('SET_C_BREAD', breadList)
            next()
            // lk.compareToken({ username: username, token: token }).then(res => {
            //     if (res.code == 200) {
            //         Store.dispatch('GetInfo')
            //         Store.dispatch('GetMenu')
            //         // add lk 2020.4.16 start
            //         // if(to.name != null){
            //         //     if(to.meta.level > from.meta.level){
            //         //         breadList.push({path: to.path, title: to.name, level: to.meta.level})
            //         //     }else if(to.meta.level <= from.meta.level && to.path != from.path){
            //         //         breadList = [{path: to.path, title: to.name, level: to.meta.level}]
            //         //     }else if(from.name == null){
            //         //         breadList = [{path: to.path, title: to.name, level: to.meta.level}]
            //         //     }
            //         // }
            //         breadList = [{ path: to.path, title: to.name, level: to.meta.level }]
            //         Store.commit('SET_C_BREAD', breadList)
            //         // add lk 2020.4.16 end
            //         next()
            //         return
            //     } else {
            //         next('/login/2')
            //         return
            //     }
            // })
        }
    }
})



export default router


// WEBPACK FOOTER //
// ./src/router/index.js